import url from '@/utils/config';
import { ReactNode } from 'react';

/** 属性定義 */
type Props = {
  children: ReactNode;
  name: string;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: React.UIEvent<Element, UIEvent>) => void;
};

/**
 * コンポーネント描画
 * @param 属性定義
 * @returns コンポーネント
 */
const AtMainButtonLoading = ({
  children,
  name,
  className,
  disabled,
  isLoading,
  type,
  onClick,
}: Props) => {
  return (
    <button
      name={name}
      className={`atmainbutton ${className}`}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      {isLoading ? <img src={url('/images/loader.gif')} alt='処理中' /> : <span>{children}</span>}
    </button>
  );
};
/** 初期値の設定 */
AtMainButtonLoading.defaultProps = {
  className: '',
  disabled: false,
  isLoading: false,
  type: 'button',
  onClick: null,
};
export default AtMainButtonLoading;
